export const TM = () => {
  return <>&trade;</>;
};
